import { render, staticRenderFns } from "./DynamicTextarea.vue?vue&type=template&id=53b50de2&scoped=true"
import script from "./DynamicTextarea.vue?vue&type=script&lang=js"
export * from "./DynamicTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b50de2",
  null
  
)

/* custom blocks */
import block0 from "./DynamicTextarea.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports